import { useApi } from '@hooks/useApi';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { ApiError, AuthRespSuccess, StaffUser } from '@root/globalTypes';

type VerifyOtpData = {
  token: string;
  otpCode: string;
};

type VerifyOtpResponse = AuthRespSuccess<StaffUser> | ApiError;

export function isFailure(data: VerifyOtpResponse): data is ApiError {
  return (data as ApiError).message !== undefined;
}

export const useVerifyOtp = ({
  handleSuccess,
}: {
  handleSuccess: (data: AuthRespSuccess<StaffUser>) => Promise<void>;
}) => {
  const { query } = useApi();
  const [apiError, setApiError] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationFn: (data: VerifyOtpData): Promise<VerifyOtpResponse> => {
      return query({
        path: 'v1/staff/session/verify_otp',
        data: data,
        opt: {
          method: 'POST',
        },
      });
    },
    onSettled: async (data) => {
      if (!data) return;
      if (isFailure(data)) {
        setApiError(data.message);
      } else {
        await handleSuccess(data);
      }
    },
    onError: (error) => {
      setApiError(error.message);
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
};
